import t from 'tcomb';
import Register_Country  from './Register_Country';
import loadScript from 'load-script';

const districts = {};

export default function load_districts(lib_url: t.String, country, callback: t.Function) {
  t.assert(t.maybe(Register_Country).is(country));

  if (!country) {
    return callback(null);
  }

  if (districts[country]) {
    return callback(districts[country]);
  }

  const scriptURL = `${lib_url}district/${country}.js`;
  loadScript(scriptURL, function () {
    districts[country] = window.require(`district/${country}`);
    callback(districts[country]);
  });
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/load_districts.js
 **/